import {
    doc,
    updateDoc,
} from "firebase/firestore";
import merge from "lodash/merge";
import moment from "moment";
import { UserMaster } from "types";
import { db } from "../firebase";

const COLLECTION_NAME = 'user_master';

const updateUser = async (userId: string, fields: Partial<UserMaster>): Promise<void> => {
    const UPDATE_FIELDS = {
        updated_date: moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
    }

    const updatePayload = merge(UPDATE_FIELDS, fields)

    return updateDoc(doc(db, COLLECTION_NAME, userId), updatePayload)
}

export { updateUser }